export default {
    guider: {
        title: '您當前是否想獲得這些幫助：',
        more: '來幫助中心，發現更多提效技能',
    },
};
